export default "__VITE_ASSET__DQOg1iXY__"